import { render, staticRenderFns } from "./PaymentChannels.vue?vue&type=template&id=4ca1ffa9&"
import script from "./PaymentChannels.vue?vue&type=script&lang=js&"
export * from "./PaymentChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports